import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  CheckOutlined,
  CloseOutlined,
  DownOutlined,
  ExclamationCircleFilled,
  FileTextOutlined,
  Loading3QuartersOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import {
  Avatar,
  Button,
  Dropdown,
  Image,
  List,
  Modal,
  Progress,
  Space,
  Spin,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import {
  BlockCircleIcon,
  EmailIcon,
  FlagIcon,
  IgnoreMessageIcon,
  NoteArrowIcon,
  PencilLineIcon,
  SMSIcon,
  VoiceMailIcon,
  WhatsappIcon,
} from "assets/icons";
import ImgDefault from "assets/images/img_default.png";
import {
  MEDIA_CONTENT_TYPE,
  MESSAGE_DATA_TYPE,
  MESSAGE_DIRECTION_TYPE,
  MESSAGE_TYPE,
  STATUS_TYPE,
} from "constants/appConstant";
import moment from "moment";
import { AuthInfo } from "stores/slices/auth";
import { getConversationSelected } from "stores/slices/conversation";
import {
  doCreateCustomer,
  doGetCustomerDetail,
  doUpdateCustomer,
} from "stores/slices/customer";
import { doGetDetailMediaContent } from "stores/slices/mediaContent";
import {
  doGetPageMessage,
  doUpdateMessage,
  fileUpList,
  getMessage,
  getMessagesList,
  isProgressUpload,
  pageNumber,
  setMessageList,
  totalEls,
} from "stores/slices/message";
import { doGetNoteDetail } from "stores/slices/note";
import { getUserDetail, getUserList } from "stores/slices/user";
import {
  // getFirestoreMediaContent,
  getFirestoreNote,
} from "useFirebase/useFireStore";

import ModalForm from "components/forms/components/modalForm";
import EditorQuill from "components/inputs/editorQuill";
import MessageAudio from "components/messages/MessageAudio";

import NoteForm from "./noteForm";
import OptInOrOutTable from "./optInOrOutTable";

const { confirm } = Modal;

const ChatMessageBody = props => {
  // params, setParams, setServiceNumber,
  const { setServiceSelected } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const urlParam = useParams();
  const messages = useSelector(getMessagesList);
  const messageList = useMemo(() => {
    let newMessageList = [];
    newMessageList = messages.filter(item => {
      if (!item?.spam) {
        return item;
      }
    });
    return newMessageList;
  }, [messages]);

  const authInfo = useSelector(AuthInfo);
  const conversationSelected = useSelector(getConversationSelected);
  const userInfo = useSelector(getUserDetail);
  const users = useSelector(getUserList);
  const currentMesPage = useSelector(pageNumber);
  const totalElements = useSelector(totalEls);
  const isProgress = useSelector(isProgressUpload);
  const fileUploadList = useSelector(fileUpList);
  let newMessage = useSelector(getMessage);
  const [openNoteForm, setOpenNoteForm] = useState(false);
  const [openBroadcast, setOpenBroadcast] = useState(false);
  const [messageSelected, setMessageSelected] = useState(null);
  const [userList, setUserList] = useState([]);
  const [isRefreshTable, setIsRefreshTable] = useState("");
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [isLoadMoreMessages, setIsLoadMoreMessages] = useState(false);
  const [searchParam, setSearchParam] = useState({
    sortFiledBroadcastList: "createdTime",
    sortDirection: "DESC",
    pageNumber: 1,
    pageSize: 8,
    statuses: [STATUS_TYPE.ACTIVE],
  });

  const getFromUser = fromUser => {
    let user = {};
    if (fromUser) {
      user = users.find(item => item.id === fromUser);
    }
    return user;
  };

  const loadMessageData = async params => {
    setIsLoadingMessages(true);
    const { payload } = await dispatch(doGetPageMessage(params));
    if (payload && payload.status === 200) {
      let newMessages;
      let messages;
      messages = payload.data.content.map(async message => {
        if (
          message.messageType === MESSAGE_TYPE.MMS ||
          (message.messageType === MESSAGE_TYPE.WHATSAPP &&
            message.messageDataType === MESSAGE_DATA_TYPE.MEDIA) ||
          message.messageDataType === MESSAGE_DATA_TYPE.NOTE ||
          message.messageType === MESSAGE_TYPE.VOICE_MAIL
        ) {
          const { payload } = await dispatch(
            doGetDetailMediaContent({
              id: message.id,
            })
          );
          if (payload && payload.status === 200) {
            // Check media content in the list and add media content detail to the list
            if (message.id === payload.data.messageId) {
              message = {
                ...message,
                mediaMessageId: payload.data.messageId,
                mediaContents: payload.data.mediaContents,
              };
            }
          }
          if (message.messageDataType === MESSAGE_DATA_TYPE.NOTE) {
            const { payload } = await dispatch(
              doGetNoteDetail({
                id: message.id,
              })
            );
            if (payload && payload.status === 200) {
              // Check note in the list and add note detail to the list
              message = {
                ...message,
                noteMessage: payload.data,
              };
            }
          }
          return message;
        } else {
          if (message.messageDataType === MESSAGE_DATA_TYPE.NOTE) {
            const { payload } = await dispatch(
              doGetNoteDetail({
                id: message.id,
              })
            );
            if (payload && payload.status === 200) {
              // Check note in the list and add note detail to the list
              return {
                ...message,
                noteMessage: payload.data,
              };
            }
          }
          return message;
        }
      });
      newMessages = await Promise.all(messages);
      await dispatch(setMessageList(newMessages));
      await setIsLoadingMessages(false);
    }
    setIsLoadingMessages(false);
  };

  const loadMoreData = async () => {
    setIsLoadMoreMessages(true);
    const params = {
      pageNumber: currentMesPage + 1,
      pageSize: 10,
      conversationId: urlParam && urlParam.id,
    };
    const { payload } = await dispatch(doGetPageMessage(params));
    if (payload && payload.status === 200) {
      let newMessages;
      let messages;
      messages = payload.data.content.map(async message => {
        if (
          message.messageType === MESSAGE_TYPE.MMS ||
          (message.messageType === MESSAGE_TYPE.WHATSAPP &&
            message.messageDataType === MESSAGE_DATA_TYPE.MEDIA) ||
          message.messageDataType === MESSAGE_DATA_TYPE.NOTE ||
          message.messageType === MESSAGE_TYPE.VOICE_MAIL
        ) {
          const { payload } = await dispatch(
            doGetDetailMediaContent({
              id: message.id,
            })
          );
          if (payload && payload.status === 200) {
            // Check media content in the list and add media content detail to the list
            if (message.id === payload.data.messageId) {
              return {
                ...message,
                mediaMessageId: payload.data.messageId,
                mediaContents: payload.data.mediaContents,
              };
            }
          }
          if (message.messageDataType === MESSAGE_DATA_TYPE.NOTE) {
            const { payload } = await dispatch(
              doGetNoteDetail({
                id: message.id,
              })
            );
            if (payload && payload.status === 200) {
              // Check note in the list and add note detail to the list
              return {
                ...message,
                noteMessage: payload.data,
              };
            }
          }
        } else {
          if (message.messageDataType === MESSAGE_DATA_TYPE.NOTE) {
            const { payload } = await dispatch(
              doGetNoteDetail({
                id: message.id,
              })
            );
            if (payload && payload.status === 200) {
              // Check note in the list and add note detail to the list
              return {
                ...message,
                noteMessage: payload.data,
              };
            }
          }
          return message;
        }
      });
      newMessages = await Promise.all(messages);
      await dispatch(setMessageList([...messageList, ...newMessages]));
      await setIsLoadMoreMessages(false);
    }
  };

  const handleOpenOptInOrOut = () => {
    setOpenBroadcast(true);
  };

  const handleBlockUser = data => {
    confirm({
      title: data?.blockUser
        ? t("inbox.chatList.unblockUser")
        : t("inbox.chatList.blockUser"),
      icon: <ExclamationCircleFilled />,
      content: data?.blockUser
        ? t("inbox.chatList.unblockUserMsg")
        : t("inbox.chatList.blockUserMsg"),
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        const request = {
          isBlocked: !data?.blockUser,
        };
        const { payload } = await dispatch(
          doUpdateCustomer({ id: data?.customerId, data: request })
        );
        if (payload && payload.status === 200) {
          navigate("/inbox/messages");
        }
      },
      onCancel() {},
    });
  };

  const handleMarkAsSpamMessage = data => {
    confirm({
      title: t("inbox.chatList.flagThisContent"),
      icon: <ExclamationCircleFilled />,
      content: t("inbox.chatList.flagThisContentMsg"),
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        const request = {
          id: data.id,
          spam: !data.spam,
        };
        await dispatch(doUpdateMessage(request));
      },
      onCancel() {},
    });
  };

  const handleIgnoreMessage = data => {
    confirm({
      title: data?.ignore
        ? t("inbox.chatMessage.donotIgnoreMessage")
        : t("inbox.chatMessage.ignoreMessage"),
      icon: <ExclamationCircleFilled />,
      content: data?.ignore
        ? t("inbox.chatMessage.dontIgnoreMessageMsg")
        : t("inbox.chatMessage.ignoreMessageMsg"),
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        const request = {
          id: data.id,
          ignore: !data.ignore,
        };
        await dispatch(doUpdateMessage(request));
      },
      onCancel() {},
    });
  };

  const handleOptInOrOut = async (broadcastListItem, messageSelected) => {
    // Handle opt in or out
    if (broadcastListItem.broadcastListCustomer) {
      const request = {
        optin: !broadcastListItem?.broadcastListCustomer?.optin,
      };
      const { payload } = await dispatch(
        doUpdateCustomer({
          id:
            messageSelected?.messageDirection === MESSAGE_DIRECTION_TYPE.IN
              ? messageSelected?.fromUser
              : messageSelected?.toUser,
          broadcastListId: broadcastListItem?.id,
          data: request,
        })
      );
      if (payload && payload.status === 200) {
        setIsRefreshTable(uuid());
      }
    } else {
      // Handle opt in new customer to broadcast list
      const { payload } = await dispatch(
        doGetCustomerDetail({
          id:
            messageSelected?.messageDirection === MESSAGE_DIRECTION_TYPE.IN
              ? messageSelected?.fromUser
              : messageSelected?.toUser,
        })
      );
      if (payload && payload.status === 200) {
        const { contact } = payload.data;
        if (contact) {
          const request = {
            broadcastListId: broadcastListItem?.id,
            createCustomerAndContactRequests: [
              {
                phoneNumber: contact?.phoneNumber,
              },
            ],
          };
          const { payload } = await dispatch(doCreateCustomer(request));
          if (payload && payload.status === 200) {
            setIsRefreshTable(uuid());
          }
        }
      }
    }
  };

  const formatTimeAgo = seconds => {
    const date = moment(seconds)
      ?.locale("en-au")
      ?.tz(userInfo?.timeZone ? userInfo?.timeZone : moment.tz.guess())
      ?.fromNow();
    return date;
  };

  const handleGetNotes = async message => {
    const _notes = getFirestoreNote(
      authInfo?.workspaceId,
      conversationSelected?.id,
      message?.id
    );
    const payload = await Promise.all([_notes]);
    return payload;
  };

  // const handleCacheMessageList = useCallback(
  //   (messageList, conversationId) => {
  //     if (conversationId === urlParam?.id && messageList?.length > 0) {
  //       // Set message list to local storage
  //       StorageHelper.setLocalItem(
  //         `ms-c-${conversationSelected?.id}`,
  //         JSON.stringify({
  //           conversationId: conversationSelected?.id,
  //           // data: messageList,
  //           data: JSON.stringify(messageList),
  //         })
  //       );
  //     }
  //   },
  //   [conversationSelected?.id]
  // );

  const columns = [
    {
      title: t("broadcastList.title.listName"),
      width: 10,
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      isSearchable: true,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: t("broadcastList.title.status"),
      width: 10,
      dataIndex: "status",
      key: "status",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) =>
        record?.broadcastListCustomer ? (
          <Tag
            color={record.broadcastListCustomer?.optin ? "#0E9154" : "#A9122B"}
            bordered={false}
          >
            {record.broadcastListCustomer?.optin
              ? t("customer.optedIn")
              : t("customer.optedOut")}
          </Tag>
        ) : (
          ""
        ),
    },
    {
      title: t("noticeBoard.actions"),
      key: "operation",
      width: 10,
      render: (_, record) => {
        return (
          <>
            <Space size="middle">
              <Tooltip
                title={
                  record.broadcastListCustomer?.optin
                    ? t("customer.optedOut")
                    : t("customer.optedIn")
                }
              >
                <Button
                  type="text"
                  shape="circle"
                  size="middle"
                  style={{
                    marginRight: 8,
                  }}
                  onClick={() => handleOptInOrOut(record, messageSelected)}
                >
                  {record.broadcastListCustomer?.optin ? (
                    <UserDeleteOutlined />
                  ) : (
                    <UserAddOutlined />
                  )}
                </Button>
              </Tooltip>
            </Space>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    const { id } = urlParam;
    // const conversationLocally = JSON.parse(
    //   StorageHelper.getLocalItem(`ms-c-${conversationSelected?.id}`)
    // );
    if (
      id &&
      id !== "messages" &&
      conversationSelected &&
      conversationSelected.id !== null &&
      conversationSelected.id !== undefined
      //  &&
      // !conversationLocally?.conversationId
    ) {
      const params = {
        pageNumber: 1,
        pageSize: 10,
        conversationId: conversationSelected.id,
      };
      // setParams(params);
      loadMessageData(params);
    }

    // if (conversationLocally?.conversationId === conversationSelected?.id) {
    //   const messageList = JSON.parse(conversationLocally.data);
    //   if (messageList?.length > 0) {
    //     dispatch(setMessageList([...messageList]));
    //   }
    // }
  }, [conversationSelected?.id]);

  useEffect(() => {
    async function handleAddNewMessage() {
      if (
        // messageList &&
        // messageList.length > 0 &&
        conversationSelected &&
        conversationSelected?.id === newMessage?.conversationId
        // &&
        // conversationSelected?.blockUser !== undefined &&
        // conversationSelected?.blockUser !== null &&
        // !conversationSelected?.blockUser
      ) {
        let newMessageList = [...messageList];
        let index = newMessageList.findIndex(
          message => message.id === newMessage.id
        );

        if (index === -1) {
          if (
            newMessage &&
            newMessage.messageDataType === MESSAGE_DATA_TYPE.MEDIA
          ) {
            const { payload } = await dispatch(
              doGetDetailMediaContent({
                id: newMessage.id,
              })
            );
            if (payload && payload.status === 200) {
              newMessage = {
                ...newMessage,
                mediaContents:
                  payload.data.mediaContents.length > 0
                    ? payload.data.mediaContents
                    : [],
              };
              dispatch(setMessageList([newMessage, ...newMessageList]));
            }
          }

          if (newMessage?.messageDataType === MESSAGE_DATA_TYPE.MESSAGE) {
            dispatch(setMessageList([newMessage, ...newMessageList]));
          }
        } else {
          if (
            newMessage.messageType === MESSAGE_TYPE.MMS ||
            (newMessage.messageType === MESSAGE_TYPE.WHATSAPP &&
              newMessage.messageDataType === MESSAGE_DATA_TYPE.MEDIA) ||
            newMessage.messageDataType === MESSAGE_DATA_TYPE.NOTE ||
            newMessage.messageType === MESSAGE_TYPE.VOICE_MAIL
          ) {
            newMessageList[index] = {
              ...newMessage,
              mediaContents:
                newMessageList[index].mediaContents &&
                newMessageList[index].mediaContents.length > 0
                  ? newMessageList[index].mediaContents
                  : [],
            };
            let intervalId = setInterval(() => {
              const payload = handleGetNotes(newMessage);
              payload.then(res => {
                clearInterval(intervalId);
                newMessageList[index] = {
                  ...newMessageList[index],
                  noteMessage: res[0].length > 0 ? res[0] : [],
                };
                dispatch(setMessageList([...newMessageList]));
              });
            }, 1000);
          } else {
            newMessageList[index] = newMessage;
            dispatch(setMessageList([...newMessageList]));
          }
        }
      }
    }
    handleAddNewMessage();
  }, [newMessage?.id, newMessage?.status, newMessage?.messageDataType]);

  useEffect(() => {
    setUserList(users);
  }, [users]);

  useEffect(() => {
    if (messageList && messageList.length > 0) {
      let outMessageSelected = messageList.find(item => {
        return item.messageDirection === MESSAGE_DIRECTION_TYPE.OUT;
      });
      setServiceSelected(outMessageSelected);
    }
  }, [messageList]);

  const MessageOutItems = [
    {
      key: "1",
      label: <span>{t("inbox.chatMessage.addNote")}</span>,
      icon: <PencilLineIcon />,
      onClick: () => {
        setOpenNoteForm(true);
      },
      disabled:
        (conversationSelected?.lock &&
          conversationSelected?.lockSessionId !== authInfo?.sessionId) ||
        conversationSelected?.blockUser,
    },
  ];

  const MessageInItems = [
    {
      key: "1",
      label: <span>{t("inbox.chatMessage.addNote")}</span>,
      icon: <PencilLineIcon />,
      onClick: () => {
        setOpenNoteForm(true);
      },
      disabled:
        (conversationSelected?.lock &&
          conversationSelected?.lockSessionId !== authInfo?.sessionId) ||
        conversationSelected?.blockUser,
    },
    {
      key: "2",
      label: <span>{t("inbox.chatList.optOutOrOut")}</span>,
      icon: <EmailIcon />,
      onClick: () => {
        handleOpenOptInOrOut();
      },
      disabled:
        (conversationSelected?.lock &&
          conversationSelected?.lockSessionId !== authInfo?.sessionId) ||
        conversationSelected?.blockUser,
    },
    {
      key: "3",
      label: (
        <span>
          {messageSelected?.ignore
            ? t("inbox.chatMessage.donotIgnoreMessage")
            : t("inbox.chatMessage.ignoreMessage")}
        </span>
      ),
      icon: <IgnoreMessageIcon />,
      onClick: () => {
        handleIgnoreMessage(messageSelected);
      },
      disabled:
        (conversationSelected?.lockSessionId !== authInfo?.sessionId &&
          conversationSelected?.lock) ||
        conversationSelected?.blockUser,
    },
    {
      key: "4",
      label: <span>{t("inbox.chatList.flagThisContent")}</span>,
      icon: <FlagIcon color={"#626576"} width={20} height={20} />,

      onClick: () => {
        handleMarkAsSpamMessage(messageSelected);
      },
      disabled:
        (conversationSelected?.lock &&
          conversationSelected?.lockSessionId !== authInfo?.sessionId) ||
        conversationSelected?.blockUser,
    },
    {
      key: "5",
      label: (
        <span>
          {conversationSelected?.blockUser
            ? t("inbox.chatList.unblockUser")
            : t("inbox.chatList.blockUser")}
        </span>
      ),
      icon: <BlockCircleIcon />,
      disabled:
        conversationSelected?.lock &&
        conversationSelected?.lockSessionId !== authInfo?.sessionId,
      onClick: () => {
        handleBlockUser(conversationSelected);
      },
    },
  ];

  return (
    <>
      {isLoadingMessages && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Spin />
        </div>
      )}
      {isLoadMoreMessages && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <Spin />
        </div>
      )}

      {!isLoadingMessages && (
        <>
          <div
            id="scrollChatMessage"
            style={{
              overflow: "auto",
              display: "flex",
              flexDirection: "column-reverse",
            }}
            className="chatMessageBody"
          >
            <>
              <InfiniteScroll
                dataLength={messageList?.length}
                scrollableTarget="scrollChatMessage"
                className="chatInfiniteScroll"
                next={loadMoreData}
                inverse={true}
                hasMore={messageList?.length < totalElements}
              >
                <>
                  <List
                    itemLayout={"horizontal"}
                    dataSource={messageList}
                    className="chatMessageList"
                    renderItem={messageItem => (
                      <List.Item key={messageItem?.id}>
                        <div>
                          {messageItem?.messageDirection === "IN" && (
                            <div className="chatMessageIn">
                              <div>
                                <div className="chatMessageLeft">
                                  <>
                                    <span
                                      style={{
                                        position: "relative",
                                        height: "40px",
                                      }}
                                    >
                                      <Avatar
                                        size="large"
                                        icon={<UserOutlined />}
                                        src={conversationSelected?.profileImage}
                                        className="chatMessageLeftAvatar"
                                      />
                                      {messageItem?.messageType ===
                                        MESSAGE_TYPE.WHATSAPP && (
                                        <span
                                          style={{
                                            position: "absolute",
                                            top: "26px",
                                            right: "8px",
                                          }}
                                        >
                                          <WhatsappIcon />
                                        </span>
                                      )}
                                      {(messageItem?.messageType ===
                                        MESSAGE_TYPE.SMS ||
                                        messageItem?.messageType ===
                                          MESSAGE_TYPE.MMS) && (
                                        <span
                                          style={{
                                            position: "absolute",
                                            top: "26px",
                                            right: "8px",
                                          }}
                                        >
                                          <SMSIcon />
                                        </span>
                                      )}
                                      {messageItem?.messageType ===
                                        MESSAGE_TYPE.VOICE_MAIL && (
                                        <span
                                          style={{
                                            position: "absolute",
                                            top: "26px",
                                            right: "8px",
                                          }}
                                        >
                                          <VoiceMailIcon />
                                        </span>
                                      )}
                                    </span>
                                    <div>
                                      <Typography.Text
                                        style={{
                                          display: "block",
                                          fontWeight: "500",
                                          width: "auto",
                                          maxWidth: "300px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {conversationSelected?.firstName ||
                                        conversationSelected?.lastName
                                          ? `${
                                              conversationSelected?.firstName ||
                                              ""
                                            } ${
                                              conversationSelected?.lastName ||
                                              ""
                                            }`
                                          : conversationSelected?.phoneNumber}
                                      </Typography.Text>

                                      <Dropdown
                                        menu={{
                                          items: MessageInItems,
                                        }}
                                        trigger={["contextMenu"]}
                                        onOpenChange={() => {
                                          setMessageSelected(messageItem);
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "350px",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <div>
                                              <div>
                                                <Image.PreviewGroup>
                                                  {messageItem?.mediaContents &&
                                                    messageItem?.mediaContents
                                                      ?.length > 0 &&
                                                    messageItem?.mediaContents?.map(
                                                      contentItem => {
                                                        return (
                                                          <>
                                                            {contentItem?.type ===
                                                              "IMAGE" && (
                                                              <div
                                                                key={
                                                                  contentItem?.id
                                                                }
                                                                className="chatMessageImgLeft"
                                                              >
                                                                <Image
                                                                  width={100}
                                                                  loading="lazy"
                                                                  src={
                                                                    contentItem?.location
                                                                  }
                                                                  style={{
                                                                    borderRadius:
                                                                      "8px",
                                                                  }}
                                                                />
                                                              </div>
                                                            )}
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                </Image.PreviewGroup>
                                              </div>
                                            </div>
                                            <div>
                                              {messageItem?.mediaContents &&
                                                messageItem?.mediaContents
                                                  ?.length > 0 &&
                                                messageItem?.mediaContents?.map(
                                                  contentItem => {
                                                    return (
                                                      <>
                                                        {(contentItem?.type ===
                                                          "FILE" ||
                                                          contentItem?.type ===
                                                            "OTHER") && (
                                                          <div
                                                            key={
                                                              contentItem?.id
                                                            }
                                                            className="chatMessageContentLeft"
                                                          >
                                                            <div className="chatMessageMediaLeft">
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                }}
                                                              >
                                                                <Avatar
                                                                  size={"small"}
                                                                  icon={
                                                                    <FileTextOutlined />
                                                                  }
                                                                  style={{
                                                                    backgroundColor:
                                                                      "#fff",
                                                                    color:
                                                                      "#000",
                                                                    marginRight:
                                                                      "8px",
                                                                  }}
                                                                />
                                                                <Typography.Link
                                                                  href={
                                                                    contentItem?.location
                                                                  }
                                                                  download={
                                                                    true
                                                                  }
                                                                  className="chatMessageMediaContentTitle"
                                                                >
                                                                  {
                                                                    contentItem?.filename
                                                                  }
                                                                </Typography.Link>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                        {contentItem?.type ===
                                                          "AUDIO" && (
                                                          <MessageAudio
                                                            key={
                                                              contentItem?.id
                                                            }
                                                            sound={
                                                              contentItem?.location
                                                            }
                                                          />
                                                        )}
                                                        {contentItem?.type ===
                                                          MEDIA_CONTENT_TYPE.VIDEO && (
                                                          <div
                                                            key={
                                                              contentItem?.id
                                                            }
                                                            className="chatMessageContentLeft"
                                                          >
                                                            <div
                                                              className="chatMessageMediaLeft"
                                                              style={{
                                                                padding: 0,
                                                                backgroundColor:
                                                                  "none",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                }}
                                                              >
                                                                <video
                                                                  style={{
                                                                    width:
                                                                      "auto",
                                                                    height:
                                                                      "auto",
                                                                    maxWidth:
                                                                      "250px",
                                                                    maxHeight:
                                                                      "250px",
                                                                  }}
                                                                  src={
                                                                    contentItem?.location
                                                                  }
                                                                  controls
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                      </>
                                                    );
                                                  }
                                                )}
                                              {messageItem?.message !== "" && (
                                                <div
                                                  className="chatMessageContentLeft"
                                                  key={messageItem?.id}
                                                >
                                                  <div
                                                    className="chatMessageContentTitle"
                                                    style={{
                                                      backgroundColor:
                                                        messageItem?.ignore
                                                          ? "#FF8A66"
                                                          : "#DEE1E5",
                                                    }}
                                                  >
                                                    <Typography.Text
                                                      style={{
                                                        whiteSpace:
                                                          "break-spaces",
                                                        color:
                                                          messageItem?.ignore
                                                            ? "#fff"
                                                            : "",
                                                      }}
                                                    >
                                                      {messageItem?.message}
                                                    </Typography.Text>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "flex-end",
                                              alignItems: "center",
                                              width: "auto",
                                              marginLeft: "8px",
                                            }}
                                          >
                                            <Dropdown
                                              menu={{
                                                items: MessageInItems,
                                              }}
                                              trigger={["click"]}
                                              onClick={() => {
                                                setMessageSelected(messageItem);
                                              }}
                                            >
                                              <div className="chatContentLeftIcon">
                                                <Tooltip title="More options">
                                                  <Button
                                                    shape="circle"
                                                    type="text"
                                                    size="small"
                                                    icon={<DownOutlined />}
                                                  />
                                                </Tooltip>
                                              </div>
                                            </Dropdown>
                                          </div>
                                        </div>
                                      </Dropdown>

                                      {(messageItem?.message !== "" ||
                                        messageItem?.mediaContents?.length >
                                          0) && (
                                        <Space size={"small"}>
                                          {!messageItem?.ignore &&
                                          !messageItem?.read ? (
                                            <>
                                              {conversationSelected?.customerId ===
                                                messageItem?.fromUser && (
                                                <Typography className="chatMessageContentSubTitle">
                                                  {messageItem?.status ===
                                                    "PENDING" && (
                                                    <span>
                                                      {t(
                                                        "inbox.chatMessage.statusMessageIn.pending"
                                                      )}
                                                    </span>
                                                  )}
                                                  {messageItem?.status ===
                                                    "CREATED" && (
                                                    <span>
                                                      {t(
                                                        "inbox.chatMessage.statusMessageIn.created"
                                                      )}
                                                    </span>
                                                  )}
                                                  {messageItem?.status ===
                                                    "SENT" && (
                                                    <span>
                                                      {t(
                                                        "inbox.chatMessage.statusMessageIn.sent"
                                                      )}
                                                    </span>
                                                  )}
                                                  {messageItem?.status ===
                                                    "DELIVERED" && (
                                                    <span>
                                                      {t(
                                                        "inbox.chatMessage.statusMessageIn.delivered"
                                                      )}
                                                    </span>
                                                  )}
                                                  {messageItem?.status ===
                                                    "FAIL" && (
                                                    <span>
                                                      {t(
                                                        "inbox.chatMessage.statusMessageIn.fail"
                                                      )}
                                                    </span>
                                                  )}
                                                </Typography>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {userList &&
                                                userList?.length > 0 &&
                                                userList.map(userItem => {
                                                  return (
                                                    <>
                                                      {userItem?.id ===
                                                        messageItem?.ignoreBy &&
                                                        messageItem?.ignore && (
                                                          <>
                                                            <Typography
                                                              key={userItem?.id}
                                                              className="chatMessageContentSubTitle"
                                                            >
                                                              <span>
                                                                {t(
                                                                  "inbox.chatMessage.statusMessageIn.ignored"
                                                                )}
                                                              </span>
                                                              <strong>
                                                                {userItem?.firstName ||
                                                                userItem?.lastName
                                                                  ? ` ${userItem?.firstName} ${userItem?.lastName}`
                                                                  : " " +
                                                                    userItem?.email}
                                                              </strong>
                                                            </Typography>
                                                          </>
                                                        )}
                                                      {userItem?.id ===
                                                        messageItem?.readUserId &&
                                                        messageItem?.read &&
                                                        !messageItem?.ignore && (
                                                          <>
                                                            <Typography
                                                              key={userItem?.id}
                                                              className="chatMessageContentSubTitle"
                                                            >
                                                              <span>
                                                                {t(
                                                                  "inbox.chatMessage.statusMessageIn.read"
                                                                )}
                                                              </span>
                                                              <strong>
                                                                {userItem?.firstName ||
                                                                userItem?.lastName
                                                                  ? ` ${userItem?.firstName} ${userItem?.lastName}`
                                                                  : " " +
                                                                    userItem?.email}
                                                              </strong>
                                                            </Typography>
                                                          </>
                                                        )}
                                                    </>
                                                  );
                                                })}
                                            </>
                                          )}

                                          <Typography className="chatMessageContentTime">
                                            {formatTimeAgo(
                                              messageItem?.createdTime
                                            )}
                                          </Typography>
                                          <span
                                            style={{ position: "relative" }}
                                          >
                                            {messageItem?.status ===
                                              "PENDING" && (
                                              <Loading3QuartersOutlined
                                                style={{ fontSize: 10 }}
                                                spin
                                              />
                                            )}
                                            {messageItem?.status ===
                                              "CREATED" && (
                                              <CheckOutlined
                                                style={{ fontSize: 12 }}
                                              />
                                            )}
                                            {(messageItem?.status ===
                                              "DELIVERED" ||
                                              messageItem?.status ===
                                                "READ") && (
                                              <span>
                                                <CheckOutlined
                                                  style={{
                                                    fontSize: 12,
                                                    color:
                                                      messageItem?.status ===
                                                      "READ"
                                                        ? "#337AC9"
                                                        : "#9499A0",
                                                  }}
                                                />
                                                <CheckOutlined
                                                  style={{
                                                    fontSize: 12,
                                                    position: "absolute",
                                                    bottom: 2,
                                                    right: 4,
                                                    color:
                                                      messageItem?.status ===
                                                      "READ"
                                                        ? "#337AC9"
                                                        : "#9499A0",
                                                  }}
                                                />
                                              </span>
                                            )}

                                            {messageItem?.status === "FAIL" && (
                                              <CloseOutlined
                                                style={{
                                                  fontSize: 12,
                                                  color: "red",
                                                }}
                                              />
                                            )}
                                          </span>
                                        </Space>
                                      )}

                                      <div>
                                        {messageItem?.noteMessage &&
                                          messageItem?.noteMessage?.length >
                                            0 &&
                                          messageItem?.noteMessage?.map(
                                            noteItem => {
                                              return (
                                                <div
                                                  key={noteItem?.id}
                                                  style={{
                                                    position: "relative",
                                                    marginTop: 8,
                                                  }}
                                                >
                                                  <div className="noteMessageContent">
                                                    <EditorQuill
                                                      readOnly={true}
                                                      customClassName="customScrollbar borderNone"
                                                      value={noteItem?.note}
                                                    />
                                                    <span className="noteMessageIcon">
                                                      <NoteArrowIcon />
                                                    </span>
                                                  </div>
                                                  <Space
                                                    size={"small"}
                                                    style={{ display: "block" }}
                                                  >
                                                    {userList &&
                                                      userList?.length > 0 &&
                                                      userList.map(userItem => {
                                                        return (
                                                          <>
                                                            {userItem?.id ===
                                                              noteItem?.userId && (
                                                              <Typography.Text className="chatMessageContentSubTitle">
                                                                {t(
                                                                  "inbox.chatMessage.statusMessageIn.add"
                                                                )}
                                                                <strong>
                                                                  {(userItem &&
                                                                    userItem.firstName) ||
                                                                  (userItem &&
                                                                    userItem.lastName)
                                                                    ? ` ${
                                                                        userItem.firstName ||
                                                                        ""
                                                                      } ${
                                                                        userItem.lastName ||
                                                                        ""
                                                                      }`
                                                                    : " " +
                                                                        userItem &&
                                                                      userItem.email}
                                                                </strong>
                                                              </Typography.Text>
                                                            )}
                                                          </>
                                                        );
                                                      })}
                                                  </Space>
                                                </div>
                                              );
                                            }
                                          )}
                                      </div>
                                    </div>
                                  </>
                                </div>
                              </div>
                            </div>
                          )}
                          {messageItem?.messageDirection === "OUT" &&
                            messageItem?.messageStatus !== "DRAFT" && (
                              <div
                                className="chatMessageOut"
                                key={messageItem?.id}
                              >
                                <div className="chatMessageRight">
                                  <span
                                    style={{
                                      position: "relative",
                                      height: "40px",
                                    }}
                                  >
                                    {userList &&
                                      userList?.length > 0 &&
                                      userList.map(userItem => {
                                        return (
                                          <>
                                            {userItem?.id ===
                                              messageItem?.fromUser && (
                                              <>
                                                {userItem?.profileImage !==
                                                null ? (
                                                  <Avatar
                                                    size="large"
                                                    src={userItem?.profileImage}
                                                    className="chatMessageRightAvatar"
                                                  />
                                                ) : (
                                                  <Avatar
                                                    size="large"
                                                    icon={<UserOutlined />}
                                                    className="chatMessageRightAvatar"
                                                  />
                                                )}
                                                {messageItem?.messageType ===
                                                  "WHATSAPP" && (
                                                  <span
                                                    style={{
                                                      position: "absolute",
                                                      right: "0px",
                                                      top: "26px",
                                                    }}
                                                  >
                                                    <WhatsappIcon />
                                                  </span>
                                                )}
                                                {(messageItem?.messageType ===
                                                  "SMS" ||
                                                  messageItem?.messageType ===
                                                    "MMS") && (
                                                  <span
                                                    style={{
                                                      position: "absolute",
                                                      right: "0px",
                                                      top: "26px",
                                                    }}
                                                  >
                                                    <SMSIcon />
                                                  </span>
                                                )}
                                              </>
                                            )}
                                          </>
                                        );
                                      })}
                                    {getFromUser(messageItem?.fromUser) ===
                                      undefined && (
                                      <>
                                        <Avatar
                                          size="large"
                                          icon={<UserOutlined />}
                                          className="chatMessageRightAvatar"
                                        />
                                        {messageItem?.messageType ===
                                          "WHATSAPP" && (
                                          <span
                                            style={{
                                              position: "absolute",
                                              right: "0px",
                                              top: "26px",
                                            }}
                                          >
                                            <WhatsappIcon />
                                          </span>
                                        )}
                                        {(messageItem?.messageType === "SMS" ||
                                          messageItem?.messageType ===
                                            "MMS") && (
                                          <span
                                            style={{
                                              position: "absolute",
                                              right: "0px",
                                              top: "26px",
                                            }}
                                          >
                                            <SMSIcon />
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </span>

                                  <div
                                    style={{
                                      marginRight: 10,
                                    }}
                                  >
                                    <Typography.Text
                                      style={{
                                        fontWeight: "500",
                                        width: "auto",
                                        maxWidth: "300px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {userList &&
                                        userList?.length > 0 &&
                                        userList.map(userItem => {
                                          return (
                                            <>
                                              {userItem?.id ===
                                                messageItem?.fromUser && (
                                                <Typography.Text
                                                  key={userItem?.id}
                                                  style={{
                                                    display: "block",
                                                    fontWeight: "500",
                                                    width: "auto",
                                                    maxWidth: "300px",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                >
                                                  {(userItem &&
                                                    userItem.firstName) ||
                                                  (userItem &&
                                                    userItem.lastName)
                                                    ? ` ${
                                                        userItem.firstName || ""
                                                      } ${
                                                        userItem.lastName || ""
                                                      }`
                                                    : " " + userItem &&
                                                      userItem.email}
                                                </Typography.Text>
                                              )}
                                            </>
                                          );
                                        })}
                                      {getFromUser(messageItem?.fromUser) ===
                                        undefined && (
                                        <>
                                          <Typography.Text
                                            style={{
                                              display: "block",
                                              fontWeight: "500",
                                              width: "auto",
                                              maxWidth: "300px",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                            {t("inbox.chatMessage.deletedUser")}
                                          </Typography.Text>
                                        </>
                                      )}
                                    </Typography.Text>
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          width: "100%",
                                          maxWidth: "350px",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            width: "auto",
                                            marginRight: "16px",
                                          }}
                                        >
                                          <Dropdown
                                            menu={{
                                              items: MessageOutItems,
                                            }}
                                            trigger={["click"]}
                                            onClick={() => {
                                              setMessageSelected(messageItem);
                                            }}
                                          >
                                            <div className="chatMessageOutIcon">
                                              <Tooltip title="More options">
                                                <Button
                                                  shape="circle"
                                                  type="text"
                                                  size="small"
                                                  icon={<DownOutlined />}
                                                />
                                              </Tooltip>
                                            </div>
                                          </Dropdown>
                                        </div>
                                        <Dropdown
                                          menu={{
                                            items: MessageOutItems,
                                          }}
                                          trigger={["contextMenu"]}
                                          onOpenChange={() => {
                                            setMessageSelected(messageItem);
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: "auto",
                                              maxWidth: "250px",
                                            }}
                                          >
                                            <div>
                                              <>
                                                <Image.PreviewGroup>
                                                  <div
                                                    className="chatMessageImgRight"
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                    }}
                                                  >
                                                    {messageItem?.mediaContents &&
                                                      messageItem?.mediaContents
                                                        ?.length > 0 &&
                                                      messageItem?.mediaContents?.map(
                                                        contentItem => {
                                                          return (
                                                            <>
                                                              {contentItem?.type ===
                                                                "IMAGE" && (
                                                                <div
                                                                  style={{
                                                                    marginBottom:
                                                                      "8px",
                                                                  }}
                                                                >
                                                                  <Image
                                                                    key={
                                                                      contentItem?.id
                                                                    }
                                                                    loading="lazy"
                                                                    width={100}
                                                                    src={
                                                                      contentItem?.location
                                                                    }
                                                                    style={{
                                                                      marginBottom:
                                                                        "8px !improtant",
                                                                      borderRadius:
                                                                        "8px",
                                                                    }}
                                                                  />
                                                                </div>
                                                              )}
                                                            </>
                                                          );
                                                        }
                                                      )}
                                                  </div>
                                                </Image.PreviewGroup>
                                              </>

                                              {messageItem?.mediaContents &&
                                                messageItem?.mediaContents
                                                  ?.length > 0 &&
                                                messageItem?.mediaContents?.map(
                                                  contentItem => {
                                                    return (
                                                      <>
                                                        {(contentItem?.type ===
                                                          "FILE" ||
                                                          contentItem?.type ===
                                                            "OTHER") && (
                                                          <div
                                                            key={
                                                              contentItem?.id
                                                            }
                                                            className="chatMessageContentRight"
                                                            style={{
                                                              marginLeft: 10,
                                                              marginRight: 8,
                                                            }}
                                                          >
                                                            <div className="chatMessageMediaContent">
                                                              <Avatar
                                                                size={"small"}
                                                                icon={
                                                                  <FileTextOutlined />
                                                                }
                                                                style={{
                                                                  backgroundColor:
                                                                    "#DEE1E5",
                                                                  color: "#000",
                                                                }}
                                                              />
                                                              <div
                                                                style={{
                                                                  marginLeft: 8,
                                                                }}
                                                              >
                                                                <Typography.Link
                                                                  href={
                                                                    contentItem?.location
                                                                  }
                                                                  download={
                                                                    true
                                                                  }
                                                                  className="chatMessageMediaContentTitle"
                                                                >
                                                                  {
                                                                    contentItem?.filename
                                                                  }
                                                                </Typography.Link>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                        {contentItem?.type ===
                                                          "AUDIO" && (
                                                          <div
                                                            key={
                                                              contentItem?.id
                                                            }
                                                            className="chatMessageContentRight"
                                                          >
                                                            <div
                                                              className="chatMessageMediaContent"
                                                              style={{
                                                                padding: 0,
                                                                background:
                                                                  "none",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  width:
                                                                    "260px",
                                                                }}
                                                              >
                                                                <audio controls>
                                                                  <source
                                                                    src={
                                                                      contentItem?.location
                                                                    }
                                                                    type="audio/mpeg"
                                                                  />
                                                                  Your browser
                                                                  does not
                                                                  support the
                                                                  audio element.
                                                                </audio>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                        {contentItem?.type ===
                                                          "VIDEO" && (
                                                          <div
                                                            key={
                                                              contentItem?.id
                                                            }
                                                            className="chatMessageContentRight"
                                                          >
                                                            <div
                                                              className="chatMessageMediaContent"
                                                              style={{
                                                                padding: 0,
                                                                backgroundColor:
                                                                  "none",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                }}
                                                              >
                                                                <video
                                                                  style={{
                                                                    width:
                                                                      "auto",
                                                                    height:
                                                                      "auto",
                                                                    maxWidth:
                                                                      "250px",
                                                                    maxHeight:
                                                                      "250px",
                                                                  }}
                                                                  src={
                                                                    contentItem?.location
                                                                  }
                                                                  controls
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                      </>
                                                    );
                                                  }
                                                )}
                                            </div>

                                            {messageItem?.message !==
                                              undefined &&
                                              messageItem?.message !== null &&
                                              messageItem?.message !== "" && (
                                                <div className="chatMessageContentRight">
                                                  <Typography.Text
                                                    className="chatMessageTitle"
                                                    style={{
                                                      background:
                                                        messageItem?.broadcastId !==
                                                          null &&
                                                        messageItem?.broadcastId !==
                                                          undefined
                                                          ? "#8ABFFA"
                                                          : "",
                                                    }}
                                                  >
                                                    {messageItem?.message}
                                                  </Typography.Text>
                                                </div>
                                              )}
                                          </div>
                                        </Dropdown>
                                      </div>
                                      {(messageItem?.message !== "" ||
                                        messageItem?.mediaContents?.length >
                                          0) && (
                                        <Space size={"small"}>
                                          <Typography className="chatMessageContentSubTitle">
                                            {messageItem?.status ===
                                              "PENDING" &&
                                              (conversationSelected?.broadcastId ===
                                                null ||
                                                conversationSelected?.broadcastId ===
                                                  undefined) && (
                                                <span>
                                                  {t(
                                                    "inbox.chatMessage.statusMessageOut.pending"
                                                  )}
                                                </span>
                                              )}
                                            {messageItem?.status ===
                                              "CREATED" &&
                                              (conversationSelected?.broadcastId ===
                                                null ||
                                                conversationSelected?.broadcastId ===
                                                  undefined) && (
                                                <span>
                                                  {t(
                                                    "inbox.chatMessage.statusMessageOut.created"
                                                  )}
                                                </span>
                                              )}
                                            {messageItem?.status === "SENT" &&
                                              (messageItem?.broadcastId ===
                                                null ||
                                                messageItem?.broadcastId ===
                                                  undefined) && (
                                                <span>
                                                  {t(
                                                    "inbox.chatMessage.statusMessageOut.sent"
                                                  )}
                                                </span>
                                              )}
                                            {(messageItem?.status ===
                                              "DELIVERED" ||
                                              messageItem?.status === "READ") &&
                                              (messageItem?.broadcastId ===
                                                null ||
                                                messageItem?.broadcastId ==
                                                  undefined) && (
                                                <span>
                                                  {t(
                                                    "inbox.chatMessage.statusMessageOut.delivered"
                                                  )}
                                                </span>
                                              )}
                                            {messageItem?.status === "FAIL" &&
                                              (messageItem?.broadcastId ===
                                                null ||
                                                messageItem?.broadcastId ===
                                                  undefined) && (
                                                <span>
                                                  {t(
                                                    "inbox.chatMessage.statusMessageOut.fail"
                                                  )}
                                                </span>
                                              )}

                                            {messageItem?.broadcastId !==
                                              null &&
                                              messageItem?.broadcastId !==
                                                undefined && (
                                                <span>
                                                  {t(
                                                    "inbox.chatMessage.statusMessageOut.broadcast"
                                                  )}
                                                </span>
                                              )}
                                          </Typography>

                                          <Typography className="chatMessageContentTime">
                                            {formatTimeAgo(
                                              messageItem?.createdTime
                                            )}
                                          </Typography>
                                          <span
                                            style={{ position: "relative" }}
                                          >
                                            {messageItem?.status ===
                                              "PENDING" && (
                                              <Loading3QuartersOutlined
                                                style={{ fontSize: 10 }}
                                                spin
                                              />
                                            )}
                                            {messageItem?.status ===
                                              "CREATED" && (
                                              <CheckOutlined
                                                style={{
                                                  fontSize: 12,
                                                  color: "#9499A0",
                                                }}
                                              />
                                            )}

                                            {(messageItem?.status ===
                                              "DELIVERED" ||
                                              messageItem?.status ===
                                                "READ") && (
                                              <span>
                                                <CheckOutlined
                                                  style={{
                                                    fontSize: 12,
                                                    color:
                                                      messageItem?.status ===
                                                      "READ"
                                                        ? "#337AC9"
                                                        : "#9499A0",
                                                  }}
                                                />
                                                <CheckOutlined
                                                  style={{
                                                    fontSize: 12,
                                                    position: "absolute",
                                                    bottom: 2,
                                                    right: 4,
                                                    color:
                                                      messageItem?.status ===
                                                      "READ"
                                                        ? "#337AC9"
                                                        : "#9499A0",
                                                  }}
                                                />
                                              </span>
                                            )}

                                            {messageItem?.status === "FAIL" && (
                                              <CloseOutlined
                                                style={{
                                                  fontSize: 10,
                                                  color: "red",
                                                }}
                                              />
                                            )}
                                          </span>
                                        </Space>
                                      )}
                                    </>
                                    <>
                                      {messageItem?.noteMessage &&
                                        messageItem?.noteMessage?.length > 0 &&
                                        messageItem?.noteMessage?.map(
                                          noteItem => {
                                            return (
                                              <div
                                                key={noteItem?.id}
                                                style={{
                                                  position: "relative",
                                                  marginTop: 12,
                                                }}
                                              >
                                                <div className="noteMessageContent">
                                                  <EditorQuill
                                                    readOnly={true}
                                                    customClassName="customScrollbar borderNone"
                                                    value={noteItem?.note}
                                                  />
                                                  <span className="noteMessageIcon">
                                                    <NoteArrowIcon />
                                                  </span>
                                                </div>
                                                <Space
                                                  size={"small"}
                                                  style={{ display: "block" }}
                                                >
                                                  {userList &&
                                                    userList?.length > 0 &&
                                                    userList.map(userItem => {
                                                      return (
                                                        <>
                                                          {userItem?.id ===
                                                            noteItem?.userId && (
                                                            <Typography.Text className="chatMessageContentSubTitle">
                                                              {t(
                                                                "inbox.chatMessage.statusMessageOut.add"
                                                              )}
                                                              <strong>
                                                                {userItem?.firstName ||
                                                                userItem?.lastName
                                                                  ? ` ${userItem?.firstName} ${userItem?.lastName}`
                                                                  : " " +
                                                                    userItem?.email}
                                                              </strong>
                                                            </Typography.Text>
                                                          )}
                                                        </>
                                                      );
                                                    })}
                                                </Space>
                                              </div>
                                            );
                                          }
                                        )}
                                    </>
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      </List.Item>
                    )}
                  />
                </>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "wrap",
                    alignItems: "flex-end",
                    width: "100%",
                  }}
                >
                  {fileUploadList?.map(fileUpload => {
                    return (
                      <>
                        {fileUpload?.type === "IMAGE" && isProgress > 0 && (
                          <div
                            key={fileUpload?.id}
                            className="chatMessageImgRight"
                            style={{
                              position: "relative",
                              marginRight: "60px",
                            }}
                          >
                            <img
                              width={100}
                              src={ImgDefault}
                              style={{
                                borderRadius: "8px",
                                marginTop: 10,
                                marginLeft: 10,
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                bottom: 20,
                                right: 20,
                              }}
                            >
                              <Progress
                                type="circle"
                                percent={isProgress}
                                showInfo={false}
                                size="small"
                              />
                            </div>
                          </div>
                        )}
                        {fileUpload?.type === "FILE" && isProgress > 0 && (
                          <div
                            key={fileUpload?.id}
                            style={{
                              display: "flex",
                              width: "auto",
                              maxWidth: "350px",
                              backgroundColor: "#DEE1E5",
                              borderRadius: "8px",
                              padding: "14px",
                              position: "relative",
                              marginBottom: "8px",
                              marginTop: "8px",
                              marginRight: "60px",
                            }}
                          >
                            <div
                              style={{
                                opacity: 0.8,
                                padding: "8px 12px",
                                display: "flex",
                                justifyContent: "flex-end",
                                borderRadius: "12px",
                                background:
                                  "linear-gradient(153deg, #6D7DFF 0%, #4054FF 98.18%)",
                              }}
                            >
                              <Avatar
                                size={"small"}
                                icon={<FileTextOutlined />}
                                style={{
                                  backgroundColor: "#DEE1E5",
                                  color: "#000",
                                }}
                              />
                              <div
                                style={{
                                  marginLeft: 8,
                                  width: "auto",
                                  maxWidth: "250px",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                <Typography.Text style={{ color: "#fff" }}>
                                  {fileUpload?.filename}
                                </Typography.Text>
                              </div>
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                bottom: 4,
                                left: "35%",
                                zIndex: 2,
                                width: "100%",
                                margin: "0 auto",
                              }}
                            >
                              <Progress
                                type="circle"
                                percent={isProgress}
                                showInfo={false}
                                size="small"
                              />
                            </div>
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
              </InfiniteScroll>
            </>
          </div>
        </>
      )}

      <ModalForm
        title={t("inbox.chatMessage.addNote")}
        onCancel={() => setOpenNoteForm(false)}
        destroyOnClose={true}
        isOpen={openNoteForm}
        labelSubmit={t("label.save")}
        customWidth={500}
        footer={false}
      >
        <NoteForm
          setOpenNoteForm={setOpenNoteForm}
          authInfo={authInfo}
          conversationSelected={conversationSelected}
          messageSelected={messageSelected}
        />
      </ModalForm>
      <ModalForm
        title={t("inbox.chatList.optOutOrOut")}
        onCancel={() => setOpenBroadcast(false)}
        destroyOnClose={true}
        isOpen={openBroadcast}
        labelSubmit={t("label.save")}
        customWidth={800}
        footer={false}
      >
        <div style={{ width: "100%" }}>
          <OptInOrOutTable
            columns={columns}
            searchParam={{
              ...searchParam,
              workspaceId: authInfo?.workspaceId,
              customerId:
                messageSelected?.messageDirection === "IN"
                  ? messageSelected?.fromUser
                  : messageSelected?.toUser,
            }}
            setSearchParam={setSearchParam}
            isRefreshTable={isRefreshTable}
          />
        </div>
      </ModalForm>
    </>
  );
};

export default ChatMessageBody;
